export default "__VITE_ASSET__By_6qInV__"